import { action, thunk } from 'easy-peasy';
import { httpGetPumps, httpGetPump, httpCreatePump, httpUpdatePump, httpDeletePump, httpBulkUpdatePumpStatus } from "services/pumps";

const model = {
  loading: false,
  setLoading: action((state, payload) => {
    state.loading = payload
  }),
  
  pumps: [],
  setPumps: action((state, payload) => {
    state.pumps = payload
  }),
  
  addPump: action((state, payload) => {
    // Check if pump already exists to avoid duplicates
    const exists = state.pumps.some(pump => pump.id === payload.id);
    if (!exists) {
      state.pumps = [...state.pumps, payload];
    } else {
      // If exists, update instead
      state.pumps = state.pumps.map(pump => 
        pump.id === payload.id ? payload : pump
      );
    }
  }),
  
  updatePumpInState: action((state, payload) => {
    state.pumps = state.pumps.map(pump => 
      pump.id === payload.id ? payload : pump
    )
  }),

  /** Updates only pumps changed in bulk (status + current_pool set to null when status is not In Use). */
  bulkUpdatePumpsInState: action((state, { updatedIds, status }) => {
    const IN_USE = 2
    state.pumps = state.pumps.map(pump => {
      if (!updatedIds.includes(pump.id)) return pump
      return {
        ...pump,
        status,
        current_pool: status === IN_USE ? pump.current_pool : null,
      }
    })
  }),

  removePump: action((state, payload) => {
    state.pumps = state.pumps.filter(pump => pump.id !== payload)
  }),
  
  getPumps: thunk(async (actions, payload) => {
    actions.setLoading(true)
    
    try {
      const response = await httpGetPumps(payload)
      actions.setPumps(response?.data || [])
    } catch (error) {
      console.error('Error fetching pumps:', error)
    } finally {
      actions.setLoading(false)
    }
  }),
  
  getPump: thunk(async (actions, id) => {
    actions.setLoading(true)
    
    try {
      const response = await httpGetPump(id)
      return response?.data
    } catch (error) {
      console.error('Error fetching pump:', error)
      return null
    } finally {
      actions.setLoading(false)
    }
  }),
  
  createPump: thunk(async (actions, data) => {
    actions.setLoading(true)
    
    try {
      const response = await httpCreatePump(data)
      actions.addPump(response?.data)
      return response?.data
    } catch (error) {
      console.error('Error creating pump:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),
  
  updatePump: thunk(async (actions, { id, data }) => {
    actions.setLoading(true)
    
    try {
      const response = await httpUpdatePump(id, data)
      actions.updatePumpInState(response?.data)
      return response?.data
    } catch (error) {
      console.error('Error updating pump:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),
  
  deletePump: thunk(async (actions, id) => {
    actions.setLoading(true)
    
    try {
      await httpDeletePump(id)
      actions.removePump(id)
    } catch (error) {
      console.error('Error deleting pump:', error)
      throw error
    } finally {
      actions.setLoading(false)
    }
  }),

  bulkUpdatePumpStatus: thunk(async (actions, { pump_ids, status, comment, timestamp, replaced_parts }) => {
    try {
      const response = await httpBulkUpdatePumpStatus({ pump_ids, status, comment, timestamp, replaced_parts })
      const data = response?.data
      if (data?.updated?.length) {
        const updatedIds = data.updated.map((u) => u.id)
        actions.bulkUpdatePumpsInState({ updatedIds, status })
      }
      return data
    } catch (error) {
      console.error('Error bulk updating pump status:', error)
      throw error
    }
  }),
  
  count: 0,
  setCount: action((state, payload) => {
    state.count = payload
  }),
};

export default model; 